export default "__VITE_ASSET__55a0e3c3__"